import React from 'react';
import { Row, Col } from 'antd';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import GraphDistribution from '../../components/GraphDistribution';
import OutcomeLearnersCards from '../../components/OutcomeLearnerCards'

const COLORS = ['#541791', '#07B229', '#D8889B', '#002940', '#6C3C11'];

class CustomizedAxisTick extends React.Component {
  render() {
    const { x, y, stroke, payload } = this.props;
    return (
      <g transform={`translate(${x},${y})`}>
        <text x={0} y={0} dy={10} textAnchor="middle" style={{ fontSize: '12px', textAlign: 'center', fontWeight: 'bold' }} fill="#666" >{payload.value}</text>
      </g>
    );
  }
}

class TagOverViewGraphs extends React.Component {

  render() {

    const { t, barchartData, distribution, categoryList, learningOutcomes } = this.props;

    return (
      <div className="serviceTracker" style={styles.cardContainer}>
        <Row style={styles.rectangle} gutter={32} >
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
            <div style={{ width: '100%' }}>
              <p style={styles.title}>{t('Total amount of learner attributes ')}</p>
            </div>
            <div style={styles.inner}>

              <BarChart width={950} height={500} data={barchartData}
                margin={{ top: 5, right: 5, left: 5, bottom: 5 }}>
                <XAxis dataKey="name" tick={<CustomizedAxisTick />} label={{ fontWeight: 'bold' }} />
                <Tooltip />
                <Legend />
                <Bar label={{ fill: 'white', marginTop: -20, fontSize: 12 }} name="Phase 1 - Investigation" dataKey="Investigation" fill="#5C9BE4" isAnimationActive={false} />
                <Bar label={{ fill: 'white', marginTop: -20, fontSize: 12 }} name="Phase 4 - Reflection" dataKey="Reflection" fill="#19435B" isAnimationActive={false}/>
              </BarChart>
            </div>
          </Col>
        </Row>
        <Row style={styles.rectangle2}>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>

            <div style={{ width: '100%' }}>
              <p style={styles.title}>{t('Distribution of skills by category')}</p>
            </div>
            <div style={styles.inner}>
              <GraphDistribution data={distribution} colors={COLORS} />
              <div style={styles.colorbox}>
                {categoryList && categoryList.map((category, i) =>
                  <p><div className="circle" style={{ backgroundColor: COLORS[i] }} /> {t(category)}</p>
                )}
              </div>
            </div>
          </Col>
        </Row>


        <Row style={styles.rectangle3}>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
            <div style={{ width: '100%' }}>
              <p style={styles.title}>{t('Total number of relevant service learning outcomes selected in projects')}</p>
            </div>
            <div>
              <OutcomeLearnersCards learningOutcomes={learningOutcomes} />
            </div>
          </Col>
        </Row>
      </div>
    )
  }
}

export default TagOverViewGraphs;

const styles = {

  container: {
    margin: '0px 20px 20px 20px'
  },
  rectangle: {
    display: 'flex',
    height: '600px',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#FFFFFF',
    marginBottom: 30,
    marginTop: 30,
    marginLeft: 0,
    marginRight: 0,
    boxShadow: '0 1px 3px 1px rgba(119,151,178,0.16)'
  },
  title: {
    fontSize: '20px',
    color: '#485465',
    fontWeight: 600,
    marginLeft: 30,
    paddingTop: 30
  },

  inner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    width: '100%'
  },

  rectangle2: {
    display: 'flex',
    height: '493px',
    marginTop: 30,
    marginBottom: 30,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#FFFFFF',
    boxShadow: '0 1px 3px 1px rgba(119,151,178,0.16)'
  },

  rectangle3: {
    display: 'flex',
    height: '1000px',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#FFFFFF',
    boxShadow: '0 1px 3px 1px rgba(119,151,178,0.16)'
  },

  cardContainer: {
    marginLeft: '25px',
    marginRight: '25px',
    marginBottom: '25px',
    marginTop: '25px'
  },
  chart: {
    marginBottom: '25px',
    marginTop: '25px'
  }
}



// WEBPACK FOOTER //
// ./src/components/TagOverViewGraphs/index.jsx